module.exports = __webpack_public_path__ + "static/media/offers-inactive.81dcb21f.svg";